import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import {
  useGetAgeGroupDataQuery,
  useGetWeeklyDaysQuery,
} from "../../../rtk-query/slices/createProduct/ProductScheduleAndPricing/productScheduleAndPricingSlice";
import ByVehicleModal from "../../createProduct/components/CPScheduleAndPricing/modals/PSEditModals/components/ByVehicleModal";
import ByPersonModalSection from "../../createProduct/components/CPScheduleAndPricing/modals/PSEditModals/components/ByPersonModalSection";

const ProductPricingEditModal = ({
  show,
  handleClose,
  productDetail,
  productId,
  scheduleData,
  schedule,
  isExclusive,
}) => {
  const { data: weeklyData } = useGetWeeklyDaysQuery({}, { skip: !show });
  const { data: ageGroupData } = useGetAgeGroupDataQuery(productId, {
    skip: !show,
  });

  return (
    <Modal
      show={show}
      //   onHide={handleClose}
      centered
      size="lg"
      className={`cp-ps-modal-main cp-ps-step-2`}
    >
      <Modal.Body className="cp-ps-modal-body p-0">
        {isExclusive ? (
          <ByVehicleModal
            weeklyData={weeklyData}
            ageGroupData={ageGroupData}
            scheduleData={scheduleData}
            schedule={schedule}
            handleClose={handleClose}
            productDetail={productDetail}
          />
        ) : (
          <ByPersonModalSection
            weeklyData={weeklyData}
            ageGroupData={ageGroupData}
            scheduleData={scheduleData}
            schedule={schedule}
            handleClose={handleClose}
            productDetail={productDetail}
          />
        )}
      </Modal.Body>

      <div
        className="sp-ps-close-modal-icon"
        onClick={async () => {
          handleClose();
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M18 6L6 18"
            stroke="#222222"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M6 6L18 18"
            stroke="#222222"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    </Modal>
  );
};

export default ProductPricingEditModal;
